<div class="content" *ngIf="container" style="padding: 5px; font-size: 16px">
  <div class="row">
    <div class="col-md-8">
      <div class="help-block h4">
        Container Detail {{ container.shipped ? "(Shipped)" : "" }}
        <close-button></close-button>
        <button
          *ngIf="container.canPrint"
          type="button"
          class="btn btn-outline-secondary pull-right"
          tooltip="Print Container Label"
          (click)="onPrint()"
        >
          <mat-icon>print</mat-icon>
        </button>
      </div>
      <hr />
    </div>
  </div>
  <div class="card" title="Container Detail">
    <div class="card-body">
      <div class="row">
        <div class="col-md-2">
          <dt>Tracking Number:</dt>
          <dd class="type">{{ container.trackingNumber }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Waste Type:</dt>
          <dd class="wasteType">{{ container.wasteType }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Container Number:</dt>
          <dd class="type">{{ container.containerNumber }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Date Opened:</dt>
          <dd>{{ container.startDateStr }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Entered by:</dt>
          <dd>{{ container.enteredBy }} - {{ container.enteredByName }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Approved</dt>
          <dd class="tsdfProfile">{{ container.approved ? "Yes" : "No" }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Open</dt>
          <dd class="tsdfProfile">{{ container.open ? "Yes" : "No" }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <dt>Owner</dt>
          <dd>{{ container.owner }} - {{ container.ownerName }} - {{ container.phone }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Lab Number</dt>
          <dd>{{ container.labNo }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Building Number</dt>
          <dd>{{ container.office }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Charge Code</dt>
          <dd>{{ container.chargeCode }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <dt>Container Detail</dt>
          <dd class="ergNumber">{{ container.containerDetail }}</dd>
        </div>
        <div class="col-md-3">
          <dt>Disposal Facility</dt>
          <dd class="facility">{{ container.facilityName }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Container Type:</dt>
          <dd class="type">{{ container.containerType }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Volume</dt>
          <dd class="volume">{{ container.volumeUn }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Weight</dt>
          <dd class="weight">{{ container.weightUn }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <dt>WASTE STREAM</dt>
          <dd class="ergNumber">{{ container.streamName }}</dd>
        </div>
        <div class="col-md-3">
          <dt>DOT Description</dt>
          <dd class="ergNumber">{{ container.dotDescription }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Toxic</dt>
          <dd class="toxic">{{ container.toxic ? "Yes" : "No" }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Reactive</dt>
          <dd class="reactive">{{ container.reactive ? "Yes" : "No" }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Ignitable</dt>
          <dd class="ignitable">{{ container.ignitable ? "Yes" : "No" }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Corrosive</dt>
          <dd class="corrosive">{{ container.corrosive ? "Yes" : "No" }}</dd>
        </div>
        <div class="col-md-1">
          <dt>Hm</dt>
          <dd class="hm">{{ container.hm ? "Yes" : "No" }}</dd>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <dt>Profile #</dt>
          <dd class="tsdfProfile">{{ container.tsdfProfile }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Disposal Code</dt>
          <dd class="tsdfDisposalCode">{{ container.tsdfDisposalCode }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Physical State</dt>
          <dd class="physicalStateId">{{ container.physicalStateId }}</dd>
        </div>
        <div class="col-md-2">
          <dt>ERG #</dt>
          <dd class="ergNumber">{{ container.ergNumber }}</dd>
        </div>
        <div class="col-md-2">
          <dt>Bin ID</dt>
          <dd class="ergNumber">{{ container.binId }}</dd>
        </div>
      </div>

      <div class="row" style="padding-right: 10px">
        <div class="col-md-2">
          <dt>State Waste Code</dt>
          <dd class="stateWasteCode">{{ container.stateWasteCode }}</dd>
        </div>
        <div class="col-auto">
          <dt>EPA Waste Codes</dt>
          <dd class="stateWasteCode">{{ container.wasteCodesJoin }}</dd>
        </div>
      </div>
    </div>
  </div>
  <!-- Print section -->
  <div *ngIf="showPrintitems" id="testingPrint">
    <div class="label-style">
      <div style="text-align: center; color: red; font-size: 50px">HAZARDOUS WASTE</div>
      <div style="text-align: center">STATE AND FEDERAL LAW PROHIBIT IMPROPER DISPOSAL</div>
      <div style="text-align: center" class="font_small">
        <br />
        IF FOUND, CONTACT THE NEAREST POLICE OR PUBLIC SAFETY AUTHORITY, OR THE U.S. ENVIRONMENTAL
        PROTECTION AGENCY, OR THE CALIFORNIA DEPARTMENT OF TOXIC SUBSTANCES CONTROL.
      </div>
      <span class="font_small">D.O.T PSN:&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span
        id="DOT_description1"
        class="font_halfinch"
        style="position: relative; top: 0.08in; right: 0.15in"
      >
        {{ container.dotNumber }}</span
      >
      <span id="DOT_description2" class="font_medium" style="position: relative; top: 0.1in">
        {{ container.dotText }}</span
      >
      <br />
      <br />
      <span class="font_small" style="position: relative; top: 0.2in">WASTE CODE:</span>
      <span id="wastecodes" class="font_medium" style="position: relative; top: 0.2in">
        {{ container.wasteCodesJoin }}
      </span>
      <br /><br />
      <table aria-hidden="true">
        <tr>
          <td style="width: 200px">
            <span class="font_small" style="position: relative; top: 0.2in"
              >PHYSICAL STATE:&nbsp;</span
            >
          </td>

          <td>
            <span class="font_small" style="position: relative; top: 0.2in"
              >HAZARDOUS PROPERTIES:</span
            >
          </td>
        </tr>
      </table>
      <table style="width: 100%; height: 49px" aria-hidden="true">
        <tr>
          <td style="position: relative; width: 95px; top: 0.2in">
            <label class="checkbox-label"></label>

            <div *ngIf="container.isSolid">
              <label class="custom-checkbox">
                <input id="Solid" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;SOLID</span>
            </div>
            <div *ngIf="!container.isSolid">
              <input id="Solid" type="checkbox" />
              <span class="font_smallbold">&nbsp;SOLID</span>
            </div>
          </td>

          <td style="position: relative; width: 99px; top: 0.2in">
            <label class="checkbox-label"></label>
            <div *ngIf="container.isGas">
              <label class="custom-checkbox">
                <input id="Gas" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;GAS</span>
            </div>
            <div *ngIf="!container.isGas">
              <input id="GAS" type="checkbox" />
              <span class="font_smallbold">&nbsp;GAS</span>
            </div>
          </td>
          <td style="position: relative; width: 125px; top: 0.2in">
            <label class="checkbox-label"></label>
            <div *ngIf="container.ignitable">
              <label class="custom-checkbox">
                <input id="Ignitable" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;IGNITABLE</span>
            </div>
            <div *ngIf="!container.ignitable">
              <input id="ignitable" type="checkbox" />
              <span class="font_smallbold">&nbsp;IGNITABLE</span>
            </div>
          </td>

          <td style="position: relative; top: 0.2in">
            <label class="checkbox-label" for="toxic"></label>
            <div *ngIf="container.toxic">
              <label class="custom-checkbox">
                <input id="Toxic" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;TOXIC</span>
            </div>
            <div *ngIf="!container.toxic">
              <input id="toxic" type="checkbox" />
              <span class="font_smallbold">&nbsp;TOXIC</span>
            </div>
          </td>
        </tr>

        <tr>
          <td style="position: relative; width: 95px; top: 0.2in">
            <label class="checkbox-label"></label>
            <div *ngIf="container.isLiquid">
              <label class="custom-checkbox">
                <input id="liquid" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;LIQUID</span>
            </div>
            <div *ngIf="!container.isLiquid">
              <input id="liquid" type="checkbox" />
              <span class="font_smallbold">&nbsp;LIQUID</span>
            </div>
          </td>

          <td style="width: 99px">&nbsp;</td>
          <td style="position: relative; width: 125px; top: 0.2in">
            <label class="checkbox-label"></label>
            <div *ngIf="container.corrosive" class="corrosive">
              <label class="custom-checkbox">
                <input id="Corrosive" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;CORROSIVE</span>
            </div>
            <div *ngIf="!container.corrosive">
              <input id="corrosive" type="checkbox" />
              <span class="font_smallbold">&nbsp;CORROSIVE</span>
            </div>
          </td>
          <td style="position: relative; top: 0.2in">
            <label class="checkbox-label"></label>
            <div *ngIf="container.reactive">
              <label class="custom-checkbox">
                <input id="Reactive" type="checkbox" checked />
                <span class="checkmark"></span>
              </label>
              <span class="font_smallbold">&nbsp;REACTIVE</span>
            </div>
            <div *ngIf="!container.reactive">
              <input id="reactive" type="checkbox" />
              <span class="font_smallbold">&nbsp;REACTIVE</span>
            </div>
          </td>
        </tr>
      </table>
      <br />
      <br />
      <table style="width: 100%; height: 38px" aria-hidden="true">
        <tr style="height: 19px">
          <td>
            <span class="font_small" style="width: 80px">GENERATOR:</span>
          </td>
          <td class="font_small_medium_bold">
            {{ generator.company }}
          </td>
          <td>
            <span class="font_small">EPA# </span>
            <span class="font_small_medium_bold">&nbsp; {{ generator.id }}</span>
          </td>
        </tr>
        <tr style="height: 19px">
          <td style="width: 80px"></td>
          <td class="font_small_medium_bold">
            {{ generator.mailingAddress }}
          </td>
          <td></td>
        </tr>
      </table>
      <br />

      <table style="width: 100%" aria-hidden="true">
        <tr>
          <td class="font_small" style="width: 80px">START DATE:</td>

          <td>
            <span id="start_date" class="font_large" style="border: 2px solid black">
              {{ container.startDateStr }}</span
            >
          </td>
          <td>
            <span class="font_small" style="position: relative; right: 0.27in">MANIFEST#</span>
            <span
              id="shippingpaper_num"
              class="font_medium"
              style="position: relative; right: 0.27in"
            >
              {{ container.trackingNumber }}</span
            >
          </td>
        </tr>
      </table>
      <table style="width: 100%" aria-hidden="true">
        <tr>
          <td style="width: 44%">
            <span class="font_small">Container ID:&nbsp;</span>
            <span id="container_id" class="font_large"> {{ container.containerNumber }}</span>
          </td>

          <td style="width: 56%">
            <span class="font_small">PROFILE&nbsp;&nbsp;</span>
            <span class="font_large">{{ container.tsdfProfile }}</span>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
  </div>
</div>
